<template>
  <div id="user-list">
    <!-- list filters -->
    <v-card>
      <v-card-text>
        <CRUDTable
          ref="theTable"
          :external-loading="loading"
          :remote-create-item="remoteCreateItem"
          :remote-update-item="remoteUpdateItem"
          :remote-delete-item="remoteDeleteItem"
          :remote-get-item="remoteGetItem"
          :fetch-list="fetchList"
          edit-with="1000px"
          :search-key-word="searchKeyWord"
          :form-config="formConfig"
          :input-configs="inputConfigs"
          :create-params-callback="createParamsCallback"
          :extra-input-call-back="extraInputCallBack"
          :disable-create="true"
          :extra-input-validation="extraInputValidation"
          @reset="handleReset"

          @openEditDialog="openEditDialog"
          @setupExtraInput="listenExtraInput"
          @openDeleteDialog="openDeleteDialog"
        >
          <template v-slot:extraInput>
            <v-container>
              <v-card>
                <v-card-text>
                  <ImageCropper
                    v-model="avatarFile"
                  >
                  </ImageCropper>
                </v-card-text>
              </v-card>
            </v-container>
          </template>
        </CRUDTable>
      </v-card-text>
    </v-card>
  </div>
</template>

<script setup>
import sha512 from 'crypto-js/sha512'
import {
  mdiAccountOutline,
  mdiDeleteOutline,
  mdiDotsVertical,
  mdiExportVariant,
  mdiFileDocumentOutline,
  mdiPlus,
  mdiSquareEditOutline,
} from '@mdi/js'
import { ref, onMounted } from 'vue'
import moment from '@/utils/moment'
import {
  createItem as remoteCreateItem, deleteItem as remoteDeleteItem,

  fetchList, updateItem as remoteUpdateItem, getItem as remoteGetItem,
} from '@/api/student'

import { objectToFormData, loading as loadingOverlay, base64ToFile } from '@/utils/helper'
import ImageCropper from '@/components/Avatar/ImageCropper'

import UniversalInput from '@/components/CRUD/UniversalInput'
import InputContainer from '@/components/CRUD/InputContainer'

import CRUDTable from '@/components/CRUD/CRUDTable'
import { useStore } from '@/store'

const theTable = ref(null)

function handleReset() {
  console.log('handleReset')
  avatarFile.value = ''
}
function onEditDialog(action) {
  console.log('action', action)
}
const store = useStore()
const loading = ref(false)
const searchKeyWord = ref('')

const centerList = ref([])
const selectedCenterList = ref([])

const courseList = ref([])
const selectedCourseList = ref([])

const editDialog = ref(false)
const editIndex = ref(-1)
const hintSentence = ref('')

const editSysRoleList = ref([])

const sysRole = ref(null)

const sysRoleList = ref([])

const userSysRoleList = ref([])

const radios = ref(0)

const selectedCoachCenterList = ref([])
const selectedCoachCourseList = ref([])

const deleteDialog = ref(false)

const editBasicSalary = ref(null)
const editPosition = ref('')

const avatarFile = ref('')
const extraInputValidation = ref(false)

const extraInput = ref([{

  value: editBasicSalary,
  propName: 'basicSalary',
  label: 'Basic Salary',

  Rules: [
    v => !!v || 'BasicSalary is requierd',

    // v =>  {console.log('basicSalary', typeof v)   },
    v => {
      if (typeof v === 'string') {
        const bool = /^\d+$/.test(v)
        if (!bool) {
          return 'Please enter number'
        }
      }
    },

  ],

  // typeof v  === "number" || 'please enter number'
},
{

  value: editPosition,
  propName: 'Position',
  label: 'Position',
  Rules: [
    v => !!v || 'Position is required',
    v => typeof v === 'string' || 'Please enter Position name',
  ],

},
])

onMounted(() => {
  // store.dispatch('center/list', {})
  //   .then(result => {
  //     console.log('center result', result)
  //     centerList.value = result.items
  //     for (let index = 0; index < centerList.value.length; index += 1) {
  //       // selectedCenterList.value = [...centerList.value.code]
  //       const value = centerList.value[index].id
  //       selectedCenterList.value.push(value)

  //       console.log('selectedCenterList.value', selectedCenterList.value)
  //     }

  //     console.log('centerList.value', centerList.value)

  //     store.dispatch('course/list', {})
  //   .then( courseReponse => {
  //     courseList.value = courseReponse.items

  //     for (let index = 0; index < courseList.value.length; index += 1) {
  //       // selectedCenterList.value = [...centerList.value.code]
  //       const value = courseList.value[index].id
  //       selectedCourseList.value.push(value)

  //       console.log('selectedCourseList.value', selectedCourseList.value)
  //     }

  //     theTable.value.fetchData()
  //   }).catch(err => {
  //     console.log('err', err)

  //   })

  //     // theTable.value.fetchData()
  //   })
  //   .catch(err => {
  //     console.log('err', err)
  //   })

  store.dispatch('sysRole/studentlist', {}).then(result => {
    sysRoleList.value = result.items
    console.log('sysRole/studentlist', sysRoleList.value)
  })
    .catch(err => {
      console.log('err', err)
    })
})

function createParamsCallback(params) {
  params.centerList = selectedCenterList.value
  params.courseList = selectedCourseList.value

  // console.log('params.centerList', params.centerList)

  return params
}

function eventCheckbox(e) {
  // console.log('eventCheckbox', e)
  selectedCenterList.value = [...e]
  theTable.value.fetchData()
}

function eventCourseCheckbox(e) {
  // console.log('eventCheckbox', e)
  selectedCourseList.value = [...e]
  console.log('eventCourseCheckbox', selectedCourseList.value)
  theTable.value.fetchData()
}

function eventCheckSysRoleEditbox(e) {
  console.log('eventCheckSysRoleEditbox', e)

  // selectedRoleList.value = [...e]
}

function listenExtraInput(e) {
  console.log('listenExtraInput(e)', e)

  radios.value = 0
  selectedCoachCenterList.value = []

  userSysRoleList.value = e.sysUserRoles

  const duplicatedRecords = sysRoleList.value.filter(item1 => userSysRoleList.value.some(item2 => item2.sysRoleID === item1.id))

  // console.log('duplicatedRecords', duplicatedRecords)
  if (duplicatedRecords) { radios.value = duplicatedRecords[0].id }

  try {
    // avatarFile.value = computed(() => process.env.VUE_APP_BASE_API + e.avatar || 'https://cdn.vuetifyjs.com/images/lists/1.jpg')
    avatarFile.value = process.env.VUE_APP_BASE_API + e.avatar
  } catch (err) {
    console.log('errerr', err)
    avatarFile.value = ''
  }
}

function openEditDialog(e) {
  console.log('openEditDialog', e)
  editIndex.value = e
  console.log('theTable.value.getEditedItem()', theTable.value.getEditedItem())

  // try{
  //  editPosition.value =  theTable.value.getEditedItem()
  //  editBasicSalary.value  =  theTable.value.getEditedItem()
  //   // theTable.value.getEditedItem()
  // }catch{

  // }

  if (e > -1) {
    editDialog.value = false
  } else {
    editDialog.value = true
  }

  // console.log('editDialog.value', editDialog.value)
  // console.log('hintSentence.value', hintSentence.value)
}

function eventCoachCenterCheckbox(e) {
  console.log('eventCoachCenterCheckbox', e)

  // console.log('listenExtraInput', e)

  selectedCoachCenterList.value = [...e]
}

function eventCoachCourseCheckbox(e) {
  console.log('eventCoachCourseCheckbox', e)

  // console.log('listenExtraInput', e)

  selectedCoachCourseList.value = [...e]
}

async function extraInputCallBack(e) {
  // e.SysRoleID = radios.value
  e.SysRoleID = sysRoleList.value[0].id

  if (e.confirmedPassword == e.password && (e.password != '' && e.confirmedPassword != '')
  && (e.password !== undefined && e.confirmedPassword !== undefined)) {
    e.confirmedPasswordSha = sha512(e.confirmedPassword.trim()).toString()
  }

  const formData = objectToFormData(e)

  if (avatarFile.value == '') {
    // if (extraInputValidation.value == true)
    //   alert('please upload an avatar file')

    extraInputValidation.value = false
  }

  if (avatarFile.value != '') {
    extraInputValidation.value = true
    const avatarFileObj = await base64ToFile(avatarFile.value, 'avatar.png')
    formData.append('avatarFile', avatarFileObj)
  }

  return formData
}

function openDeleteDialog(e) {
  console.log('openDeleteDialog', e)
  deleteDialog.value = e

  if (e == false) {
    editDialog.value = false
    radios.value = 0
    selectedCoachCenterList.value = []
    selectedCoachCourseList.value = []

    userSysRoleList.value = []

    editBasicSalary.value = null

    editPosition.value = null
  }
}

const sysRoleConfig = ref([{
  propName: 'sysRoleID',
  label: 'Role',
  required: true,
  type: {
    name: 'checkboxGroup',
    isHorizontal: true,
    groupItems: [
      { propName: 'COACH_FT', itemValue: 2, itemName: 'sysRoleID', label: 'COACH(FT)' },
      { propName: 'COACH_FL', itemValue: 3, itemName: 'sysRoleID', label: 'COACH(FL)' },
    ],
  },
}])

const formConfig = {
  delete: { title: 'Terminate' },
  title: 'StudentProfiles',
  searchLabel: 'Search for mobile, name and email',
  headers: [
    { value: 'id', text: 'Id' },
    { value: 'sysRole', text: 'Role', sortable: false },
    { value: 'userNo', text: 'UserNo' },
    { value: 'firstName', text: 'FirstName' },
    { value: 'lastName', text: 'LastName' },
    { value: 'mobileNo', text: 'MobileNo' },
    { value: 'email', text: 'Email' },
    { value: 'gender', text: 'Gender' },
    { value: 'hkid', text: 'HKID' },
    { value: 'userRegisterYear', text: 'Register year' },

    { value: 'actions', text: 'Actions', sortable: false },
  ],

  customColumns: [
    {

      name: 'sysRole',
      callback(sysRole, record) {
        let role = ''
        for (let index = 0; index < record.sysUserRoles.length; index += 1) {
          role += `${record.sysUserRoles[index].sysRole.name},`
        }
        role = role.slice(0, -1)

        return role
      },
    }],
}

const icons = ref({
  mdiSquareEditOutline,
  mdiFileDocumentOutline,
  mdiDotsVertical,
  mdiDeleteOutline,
  mdiPlus,
  mdiExportVariant,
  mdiAccountOutline,
})
const inputConfigs = ref([
  {
    propName: 'firstName',
    label: 'First Name',
    type: {
      rules: [
        v => (typeof v === 'string' && v.length > 0) || 'First Name is required',
      ],
    },

  },
  {
    propName: 'lastName',
    label: 'Last Name',
    type: {
      rules: [
        v => (typeof v === 'string' && v.length > 0) || 'Last Name is required',
      ],
    },
  },

  {
    propName: 'hkid',
    label: 'HK ID',
    type: {
      rules: [
        // e.g. a123456(7)
        v => (typeof v === 'string' && v.length === 10) || 'HKID is required',
      ],
    },
  },

  {
    hint: (editDialog.value ? 'if you are in edit mode, you can no input any password in this textbox that you dont change password' : ''),
    propName: 'password',
    label: 'Password',
    type: {
      inputType: 'password',
      rules: [
        // e.g. a123456(7)
        v => {
          if (editDialog.value) {
            if (v === undefined) { return null }

            if ((v.length == 0 && typeof v === 'string')) { return null }

            if (!(v.length >= 8 && typeof v === 'string')) {
              return 'password is required or length is more than 8'
            }
          } else {
            console.log('editDialog.value2222', editDialog.value)
            if (!(typeof v === 'string' && v.length >= 8)) {
              return 'password is required or length is more than 8'
            }
          }
        },
      ],
    },
  },
  {
    propName: 'confirmedPassword',
    label: 'Password',
    type: {
      inputType: 'password',
      rules: [

        // e.g. a123456(7)
        v => {
          if (editDialog.value) {
            if (v === undefined) { return null }

            if ((v.length == 0 && typeof v === 'string')) { return null }

            if (!(v.length >= 8 && typeof v === 'string')) {
              return 'password is required or length is more than 8'
            }

            const { confirmedPassword } = theTable.value.getEditedItem()
            const { password } = theTable.value.getEditedItem()

            if (password !== confirmedPassword && typeof v === 'string') {
              return 'not same password'
            }
          } else {
            if (!(typeof v === 'string' && v.length >= 8)) {
              return 'password is required or length is more than 8'
            }
            const { confirmedPassword } = theTable.value.getEditedItem()
            const { password } = theTable.value.getEditedItem()
            if (password !== confirmedPassword) {
              return 'not same password'
            }
          }
        },
      ],
    },
  },

  {
    propName: 'birthday',
    label: 'Birthday',

    type: {
      name: 'datepicker',
      allowedDates: (val => {
        const result = moment(val).isBefore(moment())

        // console.log('allowedDates val result', val, result)

        return result
      }),
      rules: [
        // e.g. 1992-01-01
        v => (typeof v === 'string' && v.length === 10) || 'Birthday is required',
      ],
    },
  }, {
    propName: 'gender',
    label: 'Gender',
    required: true,
    type: {
      name: 'radioGroup',
      isHorizontal: true,
      groupItems: [
        { itemValue: 'M', itemName: 'M', label: 'Male' },
        { itemValue: 'F', itemName: 'F', label: 'Female' },
      ],
    },
  }, {
    propName: 'mobileNo',
    label: 'Telephone',
    required: true,
    type: {
      rules: [
        // e.g. 91123232
        v => (typeof v === 'string' && v.length === 8) || 'Telephone is required',
      ],
    },
  }, {
    propName: 'email',
    label: 'Email',
    required: true,
    type: {
      rules: [
        // e.g. 91123232
        v => (typeof v === 'string' && v.length > 0) || 'Email is required',
      ],
    },

  },

  // { md: 12, propName: 'firstName ', label: 'FirstName' , },
  // { md: 12, propName: 'lastName ', label: 'LastName' },
  // { md: 12, propName: 'nickName  ', label: 'NickName ' },
  // { md: 12, propName: 'userName  ', label: 'UserAccount' },
  // { md: 12, propName: 'gender  ', label: 'Gender ' , hint: 'M or F'},

  // { md: 12, propName: 'email  ', label: 'Email '  },
  // { md: 12, propName: 'Password  ', label: 'password' },
  // { md: 12, propName: 'hKID  ', label: 'HKID ' },
  // { md: 12, propName: 'mobileNo   ', label: 'MobileNo' },

  // { md: 12, propName: 'birthday ', label: 'Birthday ' },
])
</script>

<style lang="scss">
@import '@core/preset/preset/apps/user.scss';
</style>
